import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { API_URL } from '../constants';
import { AuthResponse } from '../interfaces/auth.interface';
import { BotsResponse } from '../interfaces/bot.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl = API_URL;

  constructor(private http: HttpClient, private router: Router) {}

  static getAccessToken(): string {
    const authData: any = JSON.parse(
      localStorage.getItem('ngStorage-authData') || JSON.stringify(null)
    );
    return authData?.access_token || '';
  }

  static isAuthenticated(): boolean {
    const authData: any = localStorage.getItem('ngStorage-authData')
      ? JSON.parse(
          localStorage.getItem('ngStorage-authData') || JSON.stringify(null)
        )
      : null;
    return authData && (authData?.account_id || authData?.global_id);
  }

  logout(): void {
    localStorage.removeItem('ngStorage-authData');
    this.router.navigate(['/auth']);
  }

  static getAccountId(): string {
    const authData: any = JSON.parse(
      localStorage.getItem('ngStorage-authData') || JSON.stringify(null)
    );
    return authData?.account_id || '';
  }

  sendOtp(email: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/user/otp`, { email });
  }

  registerUser(email: string, portal: string): Observable<any> {
    const randomPassword = this.generateRandomPassword();

    return this.http.post(`${this.baseUrl}/user/registration`, {
      email: email,
      password: randomPassword,
      portal: portal,
      first_name: '',
      last_name: '',
      secret_code: '',
    });
  }

  getPortalId(domain: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/portal?domain=${domain}`);
  }

  private generateRandomPassword(): string {
    const chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    let password = '';
    for (let i = 0; i < 12; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  }

  verifyOtp(email: string, otp: string): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.baseUrl}/user/login`, {
      email: email,
      one_time_password: otp,
    });
  }

  saveAuthData(authData: AuthResponse): void {
    const userData = authData.user || authData;
    localStorage.setItem('ngStorage-authData', JSON.stringify(userData));
  }

  getBots(limit: number = 20, offset: number = 0): Observable<BotsResponse> {
    return this.http.get<BotsResponse>(`${this.baseUrl}/bots?limit=${limit}&offset=${offset}`);
  }

  regularLoginUser(email: string, password: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/user/login`, {
      email: email,
      password: password,
    });
  }
} 